import { useMemo } from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { makeSelectOngoingQueueCalls } from 'flow/selectors/queue-selectors';
import { CallRecordKey, QueueKey } from 'flow/types/EntityKeys';
import PbxActiveCallItem from 'flow/components/pbx/PbxActiveCallItem';

interface Props {
    queueKey: QueueKey;
}

const OngoingQueueCalls = ({ queueKey }: Props) => {
    const selectOngoingQueueCalls = useMemo(makeSelectOngoingQueueCalls, []);
    const ongoingQueueCalls = useAppSelector((state) =>
        selectOngoingQueueCalls(state, queueKey),
    );

    if (!ongoingQueueCalls?.size) return null;

    return (
        <>
            {ongoingQueueCalls
                .keySeq()
                .map((callKey: CallRecordKey) => (
                    <div key={callKey}>
                        <PbxActiveCallItem
                            callKey={callKey}
                            queueKey={queueKey}
                            isOmniErrand={false}
                        />
                    </div>
                ))
                .toArray()}
        </>
    );
};

export default OngoingQueueCalls;
